import { i as p, x as o, s as m } from "../../../lit-element-6iugfgmM.js";
import { e as b } from "../../../custom-element-wk-AooBb.js";
import { n as d } from "../../../property-BWlAHqg_.js";
import "../../../query-assigned-elements-B8U94KLQ.js";
import "../../../sp-button-km6Wkq2b.js";
import { A as h } from "../../../AlertDialog-CEu_O77_.js";
import { d as c } from "../../../define-element-Dl91r6Vu.js";
import { Localize as y } from "../../../lib/I18N.js";
import u from "../../../events/LibrariesRetryEvent.js";
c("sp-alert-dialog", h);
const f = { "libraries-error-dialog.body": "Please try again.", "libraries-error-dialog.cancel-button": "Cancel", "libraries-error-dialog.heading": "Something went wrong", "libraries-error-dialog.retry-button": "Try again", "libraries-error-dialog.heading-no-retry": "Libraries couldn't sync right now", "libraries-error-dialog.body-no-retry": "Please try again, or come back later.", "libraries-error-dialog.no-retry": "Dismiss" }, v = p`:host{--mod-alert-dialog-min-width: 480px;--mod-alert-dialog-padding: 36px}#heading{align-items:center;border-bottom:2px solid var(--spectrum-gray-400);display:flex;justify-content:space-between;padding-bottom:8px}h2{font-size:18px;margin:0;text-align:left;text-wrap:wrap}p{text-align:left}sp-icon-alert{color:var(--spectrum-orange-600)}#retry-btn{--mod-button-border-color-default: var(--spectrum-gray-900)}sp-alert-dialog [slot=heading]{min-width:calc(var(--mod-alert-dialog-min-width) - 2 * var(--mod-alert-dialog-padding) - var(--spectrum-alert-dialog-icon-size) - var(--spectrum-alert-dialog-title-to-icon));margin-bottom:12px}`;
var x = Object.defineProperty, w = Object.getOwnPropertyDescriptor, a = (g, e, s, i) => {
  for (var l, r = i > 1 ? void 0 : i ? w(e, s) : e, n = g.length - 1; n >= 0; n--) (l = g[n]) && (r = (i ? l(e, s, r) : l(r)) || r);
  return i && r && x(e, s, r), r;
};
let t = class extends y(m, f) {
  constructor() {
    super(...arguments), this.noRetry = !1, this.retryCount = 0, this.dismiss = !1;
  }
  static get styles() {
    return v;
  }
  updated() {
    this.dismiss = this.noRetry || this.retryCount >= 2;
  }
  render() {
    return o`<sp-alert-dialog aria-label="${this.t("libraries-error-dialog.heading")}" size="m" variant="error">${this._renderDialogMessage()} ${this._renderDialogExitButtons()} ${this.dismiss ? "" : o`<sp-button id="retry-btn" slot="button" static-color="black" treatment="outline" @click="${this._handleRetryClick}">${this.t("libraries-error-dialog.retry-button")}</sp-button>`}</sp-alert-dialog>`;
  }
  _handleRetryClick() {
    this.retryCount < 2 && this.dispatchEvent(new u());
  }
  _handleClose() {
    this.dispatchEvent(new Event("close", { bubbles: !0, composed: !0 }));
  }
  _renderDialogMessage() {
    return o`<h2 slot="heading">${this.dismiss ? this.t("libraries-error-dialog.heading-no-retry") : this.t("libraries-error-dialog.heading")}</h2><p>${this.dismiss ? this.t("libraries-error-dialog.body-no-retry") : this.t("libraries-error-dialog.body")}</p>`;
  }
  _renderDialogExitButtons() {
    return o`<sp-button slot="button" treatment="outline" variant="secondary" @click="${this._handleClose}">${this.dismiss ? this.t("libraries-error-dialog.no-retry") : this.t("libraries-error-dialog.cancel-button")}</sp-button>`;
  }
};
a([d({ type: Boolean })], t.prototype, "noRetry", 2), a([d({ type: Number })], t.prototype, "retryCount", 2), a([d({ type: Boolean })], t.prototype, "dismiss", 2), t = a([b("af-library-error-dialog")], t);
const P = t;
export {
  P as default
};
//# sourceMappingURL=LibraryErrorDialog.js.map
